/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-28 13:41:54
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 17:59:30
 * @name: 琴行管理模块api
 * @Description: 琴行管理模块api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\pianoCompanyManage\pianoCompanyManage.api.js
 * @Author: DESKTOP-1QU67QM
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';
import { Message } from "element-ui";

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取琴行列表
 * @param {Object} data {page{Number}: 页码, limit{Number}: 每页数据量}
 * @return {Object} data -> {
 *                    total{Number}:数据总量,
 *                    list{Array}: 数据 ==> {
 *                      id{Number}:琴行ID,
 *                      agency_name{String}:琴行名称,
 *                      address{String}:琴行地址,
 *                      belong_user{Object}跟进销售 -> {
 *                        id{Number}:跟进人id,
 *                        realname{String}:跟进人姓名
 *                      },
 *                      belong_muser{Object}跟进经理 -> {
 *                        id{Number}:跟进人id,
 *                        realname{String}:跟进人姓名
 *                      },
 *                      credit_limit{Number}: 额度,
 *                      credit_month{Number}:账期
 *                    }
 *                  }
 */
export const agencyGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/agency/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加琴行
 * @param {Object} data -> {
 *                    name{String}: 琴行名称,
 *                    address{String}: 琴行地址,
 *                    belong_user_id{Number}: 跟进销售id
 *                    belong_muser_id{Number}: 跟进经理ID
 *                    credit_limit{Number}: 最高额度
 *                    credit_month{Number}: 还款周期
 *                    contact_username{Number}: 联系人姓名
 *                    contact_mobile{Number}: 联系电话
 *                 }
 */
export const agencyAdd = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  try {
    if (!data.name) {
      throw '请输入琴行名称!';
    }
    if (!data.belong_user_id) {
      throw '请选择跟进销售!';
    }
    if (!data.belong_muser_id) {
      throw '请选择销售经理!';
    }
    // if (isNaN(data.credit_limit) || Number(data.credit_limit) < 0) {
    //   throw '请输入正确的最高额度!';
    // }
    // if (!data.credit_month) {
    //   throw '请选择还款周期!';
    // }
    if (!data.contact_username) {
      throw '请输入主账号姓名!';
    }
    if (!data.contact_mobile || data.contact_mobile.length != 11) {
      throw '请输入正确的主账号联系电话!';
    }
    return apiAddInstance.post('/admin/agency/add.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 修改琴行(暂未使用)
 * @param {Object} data -> {
 *                    agency_id{Number}: 琴行id,
 *                    name{String}: 琴行名称,
 *                    address{String}: 琴行地址,
 *                    belong_user_id{Number}: 跟进销售id
 *                    belong_muser_id{Number}: 跟进经理ID
 *                    credit_limit{Number}: 最高额度
 *                    credit_month{Number}: 还款周期
 *                    contact_username{Number}: 联系人姓名
 *                    contact_mobile{Number}: 联系电话
 *                 } 
 */
export const agencyEdit = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  return apiEditInstance.post('/admin/agency/edit.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 查询琴行信息
 * @param {Object} data -> {agency_id{String}: 琴行id}
 */
export const agencyDetail = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/agency/detail.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 设置琴行负责人
 * @param {Object} data -> {
 *                    agency_ids{Array}: 琴行ID数组,
 *                    belong_user_id{Number | undefined}: 跟进销售ID,
 *                    belong_muser_id{Number | undefined}: 跟进经理ID,
 *                 }
 */
export const agencySetBelong = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  return apiEditInstance.post('/admin/agency/setBelong.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 设置琴行额度和还款周期
 * @param {Object} data -> {
 *                    agency_id: 琴行id,
 *                    credit_limit{Number | undefined}: 额度设置,
 *                    credit_month{Number | undefined}: 还款周期设置,
 *                 }
 */
export const agencySetCredit = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  return apiEditInstance.post('/admin/agency/setCredit.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除琴行
 * @param {Object} data -> {
 *                    agency_id{Number}: 琴行id
 *                 }
 */
export const agencyDelete = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/agency/delete.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 琴行列表(下拉框)
 */
export const agencyGetAllList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/agency/getAllList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 商品权限-列表
 */
export const getCatagoryGoods = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/category/getCatagoryGoods.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加商品权限
 * @param {Object} data -> {agency_id{Number}: 琴行id,goods_sku_id_level_collection{array}: 商品skuid、级别以及商品级别主键的主键集合}
 */
export const agencyGoodsAddGoods = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  try {
    if (data.goods_sku_id_level_collection.length === 0) {
      throw '请选择商品!';
    }
    if (data.goods_sku_id_level_collection.filter(x => !x.level).length > 0) {
      throw '请选择商品级别!';
    }
    return apiAddInstance.post('/admin/agency_goods/addGoods.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取琴行授权界面数据
 * @param {Object} data -> {agency_id{String}: 琴行id}
 */
export const agencyGoodsGetGoods = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/agency_goods/getGoods.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 新增琴行人员
 * @param {Object} data -> {realname{String}: 人员姓名, mobile{String}: 人员手机号}
 */
export const accountAdd = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiAdd();
  try {
    if (!data.realname) {
      throw '请输入人员姓名!';
    }
    if (!data.mobile || data.mobile.length !== 11) {
      throw '请输入正确的手机号!';
    }
    return apiSearchInstance.post('/admin/agencyUser/add.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 编辑琴行人员
 * @param {Object} data -> {id{String}: 人员id, realname{String}: 人员姓名, mobile{String}: 人员手机号}
 */
export const accountEdit = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiEdit();
  try {
    if (!data.realname) {
      throw '请输入人员姓名!';
    }
    if (!data.mobile || data.mobile.length !== 11) {
      throw '请输入正确的手机号!';
    }
    return apiSearchInstance.post('/admin/agencyUser/edit.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除琴行人员
 * @param {Object} data -> {id{String}: 人员id, realname{String}: 人员姓名, mobile{String}: 人员手机号}
 */
export const accountDelete = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiDelete();
  return apiSearchInstance.post('/admin/agencyUser/delete.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 琴行信息模板下载地址
 */
export const tempUrl = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/agency/tempUrl.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 审核琴行
 */
export const verify = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  try {
    if (data.act === 'OK' && !data.belong_user_id) {
      throw '请选择跟进销售!';
    }
    if (data.act === 'OK' && !data.belong_muser_id) {
      throw '请选择跟进销售经理!';
    }
    // if (data.act === 'OK' && !data.credit_limit) {
    //   throw '请输入最高额度!';
    // }
    // if (data.act === 'OK' && !data.credit_month) {
    //   throw '请选择还款周期!';
    // }
    return apiEditInstance.post('/admin/agency/verify.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 查询erp琴行
 */
export const getErpAgency = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/agency/getErpAgency.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 琴行绑定erp
 */
export const setErpId = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/agency/setErpId.html', data, instance);
}

